/**
 * Created by denis.gusarov on 8/11/2017.
 */
namespace Factive.Game {
    import Signal = Factive.Core.Signal.Signal;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import List = Factive.Core.Linq.List;


    export class Pixi3DSprite extends PIXI.Sprite {
        private gl: WebGLRenderingContext;
        private canvas: HTMLCanvasElement;
        //private canvasWidth: number;
        //private canvasHeight: number;
        private modelReady: boolean;
        private __width: number;
        private __height: number;

        constructor(private _diceRenderer: Factive.Game.DiceRendererClass, private _assetScale: number) {
            super();
            this.interactive = true;
            this.gl = null;
            this.canvas = null;
            this.texture = null;

            this.texture = PIXI.RenderTexture.create(2, 2);

            this.__width = 368 * this._assetScale;
            this.__height = 344 * this._assetScale;
            this.x = 0;
            this.y = 0;
            this.anchor.x = 0;
            this.anchor.y = 0;
            this.scale.y = 1;
            this.scale.x = 1;

            this.modelReady = true;
        }

        /**
         * @private
         */
        init() {
        }

        _renderWebGL(renderer) {

            if (!this.gl) {
                this.gl = renderer.gl;
                this.canvas = renderer.view;
                this.init();
            }

            if (!this.modelReady) {
                const gl = renderer.gl;
                // it is unreasonable how the next line works...😂
                gl.activeTexture(gl.TEXTURE0);
                return;
            }

            if (!this.visible) {
                return;
            }

            renderer.currentRenderer.stop();

            const useVAO = !!(renderer.createVao && renderer.bindVao);

            let _activeVao;
            if (useVAO) {
                _activeVao = (<any>renderer)._activeVao;//TODO VertexArrayObject?
            } else {
                renderer.flush();
            }

            const gl = renderer.gl;

            const arrayBuffer = gl.getParameter(gl.ARRAY_BUFFER_BINDING);
            const elementArrayBuffer = gl.getParameter(gl.ELEMENT_ARRAY_BUFFER_BINDING);
            const currentProgram = gl.getParameter(gl.CURRENT_PROGRAM);

            let activeTexture;
            if (!useVAO) {
                activeTexture = gl.getParameter(gl.ACTIVE_TEXTURE);
            }

            gl.activeTexture(gl.TEXTURE0);
            const texture0 = gl.getParameter(gl.TEXTURE_BINDING_2D);
            gl.activeTexture(gl.TEXTURE1);
            const texture1 = gl.getParameter(gl.TEXTURE_BINDING_2D);

            const frontFace = gl.getParameter(gl.FRONT_FACE);
            const colorWhiteMask = gl.getParameter(gl.COLOR_WRITEMASK);

            let vertexAttr0Enabled, vertexAttr1Enabled, vertexAttr2Enabled, vertexAttr3Enabled;
            if (!useVAO) {
                vertexAttr0Enabled = gl.getVertexAttrib(0, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
                vertexAttr1Enabled = gl.getVertexAttrib(1, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
                vertexAttr2Enabled = gl.getVertexAttrib(2, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
                vertexAttr3Enabled = gl.getVertexAttrib(3, gl.VERTEX_ATTRIB_ARRAY_ENABLED);
            }
            const scissorTestEnabled = gl.isEnabled(gl.SCISSOR_TEST);
            const stencilTestEnabled = gl.isEnabled(gl.STENCIL_TEST);
            const depthTestEnabled = gl.isEnabled(gl.DEPTH_TEST);
            const cullFaceEnabled = gl.isEnabled(gl.CULL_FACE);
            const blendEnabled = gl.isEnabled(gl.BLEND);

            const _activeTextureLocation = (<any>renderer)._activeTexture ? (<any>renderer)._activeTextureLocation : 0;//TODO _activeTexture,_activeTextureLocation ?
            const _activeRenderTarget = renderer._activeRenderTarget;

            let vao;
            if (useVAO) {
                vao = renderer.createVao();
                renderer.bindVao(vao);
            }

            let width = this.__width * this.worldTransform.a;
            let height = this.__height * this.worldTransform.d;

            gl.viewport(
                this.worldTransform.tx - width / 2,
                this.worldTransform.ty - height / 2,
                width,
                height);

            // renderer.bindRenderTexture(<PIXI.RenderTexture>this.texture, null);
            // gl.clearColor(0.0, 0.0, 0.0, 0.0);
            // gl.clear(gl.COLOR_BUFFER_BIT);
            // gl.frontFace(gl.CW);

            this._diceRenderer.render(null);


            gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);

            if (!useVAO) {
                (<any>renderer)._activeTextureLocation = _activeTextureLocation;//TODO _activeTextureLocation ?
                gl.activeTexture(gl.TEXTURE0 + _activeTextureLocation);
            }

            gl.bindTexture(gl.TEXTURE_2D, null);

            gl.useProgram(currentProgram);
            renderer.bindRenderTarget(_activeRenderTarget);

            gl.bindBuffer(gl.ARRAY_BUFFER, arrayBuffer);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, elementArrayBuffer);

            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, texture0);
            gl.activeTexture(gl.TEXTURE1);
            gl.bindTexture(gl.TEXTURE_2D, texture1);

            if (!useVAO) {
                gl.activeTexture(activeTexture);
            }
            gl.frontFace(frontFace);
            //gl.colorMask(...colorWhiteMask);
            //
            if (!useVAO) {
                vertexAttr0Enabled ? gl.enableVertexAttribArray(0) : gl.disableVertexAttribArray(0);
                vertexAttr1Enabled ? gl.enableVertexAttribArray(1) : gl.disableVertexAttribArray(1);
                vertexAttr2Enabled ? gl.enableVertexAttribArray(2) : gl.disableVertexAttribArray(2);
                vertexAttr3Enabled ? gl.enableVertexAttribArray(3) : gl.disableVertexAttribArray(3);
            }
            scissorTestEnabled ? gl.enable(gl.SCISSOR_TEST) : gl.disable(gl.SCISSOR_TEST);
            stencilTestEnabled ? gl.enable(gl.STENCIL_TEST) : gl.disable(gl.STENCIL_TEST);
            depthTestEnabled ? gl.enable(gl.DEPTH_TEST) : gl.disable(gl.DEPTH_TEST);
            cullFaceEnabled ? gl.enable(gl.CULL_FACE) : gl.disable(gl.CULL_FACE);
            blendEnabled ? gl.enable(gl.BLEND) : gl.disable(gl.BLEND);

            if (blendEnabled) {
                gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
            }

            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);

            if (useVAO) {
                vao.unbind();
                vao.destroy();
                renderer.bindVao(_activeVao);
            }

            renderer.currentRenderer.start();

            super._renderWebGL(renderer);
        }

        destroy(options?: PIXI.DestroyOptions | boolean) {
            super.destroy(options);
        }

        containsPoint(point) {
            return false;
        }

    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Dices/Pixi3DSprite.ts